import React from 'react';

const About = () => {
    React.useEffect(() => {
        document.title = "MosMaiMe - About";
    }, []);

    return (
        <div>
            <h1>About</h1>
        </div>
    );
}

export default About;